import type { AdminHardwareLostReportList } from "@/types/admin-hardware-lost-reports";

/**
 * Fixture for `GET /admin/users/{userId}/hardware-lost-reports` (mock mode).
 * One report with a linked replacement order (paid, replacement shipping)
 * and one older report that never spawned a replacement order.
 */
export const MOCK_LOST_REPORTS: AdminHardwareLostReportList = {
  items: [
    {
      id: 10,
      status: "replacement_paid",
      serials: ["ZB1-A001-77F1"],
      stateAtReport: "active",
      createdAt: "2026-06-01T10:00:00Z",
      updatedAt: "2026-06-01T10:05:00Z",
      replacementOrder: {
        publicId: "hro_abc123",
        status: "awaiting_inventory",
        amountCents: 9900,
        currency: "usd",
        createdAt: "2026-06-01T10:05:00Z",
        updatedAt: null,
      },
    },
    {
      id: 3,
      status: "reported",
      serials: ["ZB1-F006-90DA"],
      stateAtReport: "past_due",
      createdAt: "2026-02-14T08:30:00Z",
      updatedAt: null,
      replacementOrder: null,
    },
  ],
};
